























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcContactForm from '@contacts/components/forms/contact-form/contact-form.vue';

@Component({
  name: 'bpc-pos-contact-form',
  components: {
    BpcContactForm,
  },
})
export default class PosContactForm extends Vue {
  declare $refs: {
    stdForm: InstanceType<typeof BpcContactForm> & {
      saveEntity(): Promise<any>;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      prepareToSave(entity: any): AnyEntity;
    };
  };
  @Prop({ type: String }) readonly saveButtonPortalTarget!: string;

  formModel = null;
  disabledForm = false;
  isSavingForm = false;

  async createContact() {
    await this.$refs.stdForm.saveEntity();
  }
  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }

  onSavingEntity(event) {
    this.isSavingForm = event;
  }
}
